import '../css/worktimetracking.css'
import React from "react";
import {setNavi} from "../../../@WUM/core/Function/index";
import WorkTimeTracking from "./components/WorkTimeTracking";
import TimeTrackingDashboardWidget from "./components/TimeTrackingDashboardWidget";
import {UniRow} from "../../../@WUM/core/Elements";
import HolidayDashboardWidget from "./components/HolidayDashboardWidget";
const WorkTimeTrackingOverview = (props:{value:any}) => {
    setNavi({
        route: '/support/software/overview'
    })


    return (
        <>
            <UniRow>
                <TimeTrackingDashboardWidget />
                <WorkTimeTracking />
                <HolidayDashboardWidget />

            </UniRow>

        </>
    )
}
export default WorkTimeTrackingOverview;
